export const selectCaseStates = (state) => state.caseStates.caseStates;
export const selectCaseSubStates = (state) => state.caseStates.caseSubStates;

export const selectCaseStatesPag = (state) => state.caseStates.caseStatesAdmin;
export const selectCaseSubStatesPag = (state) => state.caseStates.caseSubStatesAdmin;

export const selectCaseStatesLoading = (state) => state.caseStates.loading;
export const selectCaseStatesLoadingPag = (state) => state.caseStates.loadingPag;

export const selectCaseStatesError = (state) => state.caseStates.error;

export const selectCaseSubStatesLoading = (state) => state.caseStates.subStateLoading;